export default __webpack_public_path__ + "static/media/dfl-2-rMIN.7ff42645.avif";